export const wait = (sec: number) =>
  new Promise((resolve) => setTimeout(resolve, sec * 1e3));

export const emptyFn = () => {};

export function makeid(length: number) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let result = "";

  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

export const prettyWord = (str: string) =>
  str.charAt(0).toLocaleUpperCase("tr") + str.slice(1);

export const prettyString = (str?: string) => {
  if (!str) return "";

  return str
    .split(" ")
    .map(prettyWord)
    .join(" ")
    .split("\n")
    .map(prettyWord)
    .join("\n");
};

export const trStrToEnLower = (str: string) =>
  str
    .toLocaleLowerCase()
    .replace("ğ", "g")
    .replace("ş", "s")
    .replace("ı", "i")
    .replace("ü", "u")
    .replace("ö", "o")
    .replace("ç", "c");
